import { useEditTeamModal } from './modals/edit_team'

export const useTeamsOptions = (view) => {
  const { openEditTeamModal } = useEditTeamModal()

  return [{ name: 'Edit Team', handle: openEditTeamModal }]
}
